import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SdsForm } from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";

import { PAYMENT_URLS } from "../../api/UserUrls";
import { showAlertAutoClose } from "../../services/notifyService";
import { ALLOW_NUMERIC } from "../../services/PatternSerivce";
import {
  costomer_invoice_all_select,
  vendors_get_all_select,
} from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";

interface HeaderProps {
  loadTableData: () => void;
  dataIn?: any;
}
const schema = Yup.object({});
const RecentPaymentForm: React.FC<HeaderProps> = ({
  loadTableData,
  dataIn,
}) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });

  const { setLoading, closeModal } = useSiteContext();
  const [allRole, setAllRole] = useState([]);
  const [invoice, setInvoice] = useState([]);
  const formData = watch(); // Watch all form values

  const onSubmit = (data: any) => {
    let url = PAYMENT_URLS.INSERT;

    const subscription = post(url, data).subscribe((response) => {
      showAlertAutoClose("Data Saved Successfully", "success");
      closeModal();
      loadTableData();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    vendors_get_all_select((data: any) => setAllRole(data));
  }, []);

  useEffect(() => {
    const customer_id = formData?.sd_customer_id?.value;
    if (customer_id && customer_id > 0) {
      costomer_invoice_all_select(customer_id, (data: any) => setInvoice(data));
    }
  }, [formData?.sd_customer_id]);

  const PaymentMode = [
    { value: "Payment", label: "Payment" },
    { value: "TDS", label: "TDS" },
  ];

  const formElements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 6,
      name: "sd_customer_id",
      element: {
        label: "Select Customer",
        isRequired: true,
        options: allRole,
        inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "sd_invoice_id",
      element: {
        label: "Select Invoice",
        isRequired: true,
        options: invoice,
        inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "amount_in",
      element: {
        label: "Invoice Amount",
        isRequired: true,
        inputType: "BORDER_LABEL",
        max: 15,
        disabled: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "amount_paid",
      element: {
        label: "Paid Amount",
        isRequired: true,
        disabled: true,
        inputType: "BORDER_LABEL",
        max: 15,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "amount_rem",
      element: {
        label: "Remaining Amount",
        isRequired: true,
        disabled: true,
        inputType: "BORDER_LABEL",
        max: 15,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "payment_amount",
      element: {
        label: "Enter Amount",
        isRequired: true,
        inputType: "BORDER_LABEL",
        max: 15,
      },
    },
    {
      type: "DATE",
      width: 6,
      name: "payment_date",
      element: {
        label: "Select Date",
        placeHolder: "DD-MM-YYYY",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "payment_mode",
      element: {
        label: "Payment Mode",
        isRequired: true,
        options: PaymentMode,
        inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "payment_method",
      element: {
        label: "Payment Method Details",
        isRequired: true,
        inputType: "BORDER_LABEL",
        max: 25,
      },
      hideFunction: () => {
        return !(formData.payment_mode?.value === "Payment");
      },
    },
    {
      type: "LABEL",
      width: 8,
      name: "label",
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-third-button"],
        label: "Close",
        onClick: closeModal,
      },
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <div>
      <div className="sd-efl-input">
        <SdsForm elements={formElements} errors={errors} control={control} />
      </div>
    </div>
  );
};

export default RecentPaymentForm;